// tslint:disable-next-line: variable-name
export const StateList: { [key: string]: any[]} = {
  US: [
    { stateCode: 'AK', stateName: 'states.Alaska' },
    { stateCode: 'AL', stateName: 'states.Alabama' },
    { stateCode: 'AR', stateName: 'states.Arkansas' },
    { stateCode: 'AZ', stateName: 'states.Arizona' },
    { stateCode: 'CA', stateName: 'states.California' },
    { stateCode: 'CO', stateName: 'states.Colorado' },
    { stateCode: 'CT', stateName: 'states.Connecticut' },
    { stateCode: 'DC', stateName: 'states.District of Columbia' },
    { stateCode: 'DE', stateName: 'states.Delaware' },
    { stateCode: 'FL', stateName: 'states.Florida' },
    { stateCode: 'GA', stateName: 'states.Georgia' },
    { stateCode: 'GU', stateName: 'states.Guam' },
    { stateCode: 'HI', stateName: 'states.Hawaii' },
    { stateCode: 'IA', stateName: 'states.Iowa' },
    { stateCode: 'ID', stateName: 'states.Idaho' },
    { stateCode: 'IL', stateName: 'states.Illinois' },
    { stateCode: 'IN', stateName: 'states.Indiana' },
    { stateCode: 'KS', stateName: 'states.Kansas' },
    { stateCode: 'KY', stateName: 'states.Kentucky' },
    { stateCode: 'LA', stateName: 'states.Louisiana' },
    { stateCode: 'MA', stateName: 'states.Massachusetts' },
    { stateCode: 'MD', stateName: 'states.Maryland' },
    { stateCode: 'ME', stateName: 'states.Maine' },
    { stateCode: 'MI', stateName: 'states.Michigan' },
    { stateCode: 'MN', stateName: 'states.Minnesota' },
    { stateCode: 'MO', stateName: 'states.Missouri' },
    { stateCode: 'MS', stateName: 'states.Mississippi' },
    { stateCode: 'MT', stateName: 'states.Montana' },
    { stateCode: 'NC', stateName: 'states.North Carolina' },
    { stateCode: 'ND', stateName: 'states.North Dakota' },
    { stateCode: 'NE', stateName: 'states.Nebraska' },
    { stateCode: 'NH', stateName: 'states.New Hampshire' },
    { stateCode: 'NJ', stateName: 'states.New Jersey' },
    { stateCode: 'NM', stateName: 'states.New Mexico' },
    { stateCode: 'NV', stateName: 'states.Nevada' },
    { stateCode: 'NY', stateName: 'states.New York' },
    { stateCode: 'OH', stateName: 'states.Ohio' },
    { stateCode: 'OK', stateName: 'states.Oklahoma' },
    { stateCode: 'OR', stateName: 'states.Oregon' },
    { stateCode: 'PA', stateName: 'states.Pennsylvania' },
    { stateCode: 'RI', stateName: 'states.Rhode Island' },
    { stateCode: 'SC', stateName: 'states.South Carolina' },
    { stateCode: 'SD', stateName: 'states.South Dakota' },
    { stateCode: 'TN', stateName: 'states.Tennessee' },
    { stateCode: 'TX', stateName: 'states.Texas' },
    { stateCode: 'UT', stateName: 'states.Utah' },
    { stateCode: 'VA', stateName: 'states.Virginia' },
    { stateCode: 'VI', stateName: 'states.Virgin Islands' },
    { stateCode: 'VT', stateName: 'states.Vermont' },
    { stateCode: 'WA', stateName: 'states.Washington' },
    { stateCode: 'WI', stateName: 'states.Wisconsin' },
    { stateCode: 'WV', stateName: 'states.West Virginia' },
    { stateCode: 'WY', stateName: 'states.Wyoming' },
  ],
  CA: [
    { stateCode: 'AB', stateName: 'states.Alberta' },
    { stateCode: 'BC', stateName: 'states.British Columbia' },
    { stateCode: 'MB', stateName: 'states.Manitoba' },
    { stateCode: 'NB', stateName: 'states.New Brunswick' },
    { stateCode: 'NF', stateName: 'states.Newfoundland and Labrador' },
    { stateCode: 'NS', stateName: 'states.Nova Scotia' },
    { stateCode: 'NT', stateName: 'states.Northwest Territories' },
    { stateCode: 'NU', stateName: 'states.Nunavut' },
    { stateCode: 'ON', stateName: 'states.Ontario' },
    { stateCode: 'PE', stateName: 'states.Prince Edward Island' },
    { stateCode: 'QC', stateName: 'states.Quebec' },
    { stateCode: 'SK', stateName: 'states.Saskatchewan' },
    { stateCode: 'YT', stateName: 'states.Yukon' },
  ],
};
